module.exports = require('./helpers/bundle-url').getBundleURL('duwKw') + "logo.c51670a8.svg";